import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "franktech-api.franktechspace.dev";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Token management
const TOKEN_KEY = "franktech_token";

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  delete api.defaults.headers.common["Authorization"];
};

// ✅ Check token on every request
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Initialize token if exists
const token = getAuthToken();
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// API calls
export const getErrors = async (params = {}) => {
  const response = await api.get("/api/v1/errors/", { params });
  return response.data;
};

export const getError = async (id) => {
  const response = await api.get(`/api/v1/errors/${id}/`);
  return response.data;
};

export const getAnalysis = async (id) => {
  const response = await api.get(`/api/v1/errors/${id}/analysis`);
  return response.data;
};

export const sendError = async (errorData) => {
  const response = await api.post("/api/v1/errors/", errorData);
  return response.data;
};

export default api;
